import { render, staticRenderFns } from "./CompletedPage.vue?vue&type=template&id=20e9240f&scoped=true&"
import script from "./CompletedPage.vue?vue&type=script&lang=js&"
export * from "./CompletedPage.vue?vue&type=script&lang=js&"
import style0 from "./CompletedPage.vue?vue&type=style&index=0&id=20e9240f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e9240f",
  null
  
)

export default component.exports